export default "__VITE_ASSET__DNaAAJf1__"